import { demoSiteOrigin } from '@rezonence/freewall-demo-client';

export const defaultDemoLink = demoSiteOrigin;
